export enum AuthExceptionCode {
  // 微信未绑定平台账号
  WECHAT_UNBIND = 'TP_AUTH_AUTH_0001'
}
